export const DefaultHubLVideoParams = {
  overrideable: false,
  type: 'scriptV4',
  hide_playlist: true,
  viral_sharing: false,
  embed_button: false,
  autoplay: false,
  hidden_controls: false,
  loop: false,
  muted: false,
  full_width: false
};
export const SupportedHubLVideoParams = ['hide_playlist', 'width', 'height', 'viral_sharing', 'embed_button', 'type', 'player_id', 'overrideable', 'style', 'color', 'playlist_color', 'play_button_color', 'conversion_asset', 'autoplay', 'hidden_controls', 'loop', 'muted', 'full_width', 'placeholder_alt_text'];